import { StandaloneAdTemplate } from '@/base/components/element/AdTemplate';
import { LabradorComponent } from '@/types/component';

const LabradorAdTemplate: LabradorComponent = ({ data }) => {
  return <StandaloneAdTemplate pageMeta={data?.meta} />;
};

export default LabradorAdTemplate;
